import { render, staticRenderFns } from "./ExtendOtherNutrientsAll.vue?vue&type=template&id=5e19f2b8&scoped=true"
import script from "./ExtendOtherNutrientsAll.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsAll.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsAll.vue?vue&type=style&index=0&id=5e19f2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e19f2b8",
  null
  
)

export default component.exports